import template from './sites-list.html';

import { Column } from '../common/table/model/table-column';

class SiteListController {
  constructor($state, sitesService, $filter, usersService, gettext) {
    'ngInject';

    this.sitesService = sitesService;
    this.$state = $state;
    this.$filter = $filter;
    this.usersService = usersService;
    this.gettext = gettext;

    this.defineTableProp();
    this.sites = [];
    this.filteredSites = [];
    this.loading = false;

    // functions binding to this class
    this.goToView = this.goToView.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
  }

  $onInit() {
    this.hasFullControl = this.usersService.hasRequiredFeatures(['sites.manage.create']);
    this.getSites();
  }

  getSites() {
    this.loading = true;
    this.error = false;
    this.sitesService
      .getSites()
      .then((sites) => {
        if (sites && sites.length === 1 && !this.hasFullControl) {
          const [s] = sites;
          this.goToView(null, s, null);
        }
        this.sites = sites;
        this.search();
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  defineTableProp() {
    this.columns = [
      new Column({
        title: this.gettext('Name'),
        field: 'name',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Creation Date'),
        field: 'creationDate',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Address'),
        field: 'address',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Description'),
        field: 'description',
        sortable: true,
      }),
    ];
  }

  goToView(event, item, index) {
    if (item) {
      this.$state.go('sites.view', { id: item.id });
    }
  }

  openManageView(id) {
    this.manageView = {
      show: true,
    };
  }

  closeManageView() {
    this.manageView = undefined;
    this.getSites();
  }

  onSortChange(column) {
    if (typeof column.ascending !== 'boolean') {
      this.columns.forEach((col) => {
        if (col.field !== column.field && typeof col.ascending === 'boolean')
          col.ascending = undefined;
      });
    }

    column.ascending = !column.ascending;

    this.sortList(column);
  }

  sortList(column) {
    if (typeof column === 'undefined') {
      column = this.columns.find((column) => typeof column.ascending === 'boolean');
    }

    this.filteredSites = this.filteredSites.sort(column.sort);
  }

  search() {
    if (this.query !== '') {
      this.filteredSites = this.$filter('filter')(this.sites, this.query);
    } else {
      this.filteredSites = this.sites;
    }
  }
}
export default {
  template,
  controller: SiteListController,
  controllerAs: 'vm',
};
